import { AxiosResponse } from 'axios';
import React from 'react';
import { AsyncTypeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
// eslint-disable-next-line import/no-extraneous-dependencies
import { InputLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Company from '../../../Model/company';
import '../../../pages/Contacts/contacts.css';
import { getCompanies } from '../../../api/contacts';

interface Props {
  loading: boolean;
  setNewCompany: Function;
  setCompany: Function;
  newCompany: Company | undefined;
  setLoading: Function;
  companies: any[];
  setCompanies: Function;
  company: Company | undefined;
  setBusinessName: Function;
  setVat: Function;
}

const CompanyForm = ({
  loading,
  setNewCompany,
  setCompany,
  setLoading,
  companies,
  setCompanies,
  company,
  newCompany,
  setBusinessName,
  setVat
}: Props) => {
  const { t } = useTranslation();
  return (
    <div style={{ marginBottom: 40 }}>
      {' '}
      <b className='searchTitle'>{t('SEARCH_BUSINESS_NAME')}</b>
      <AsyncTypeahead
        id={'search-company'}
        isLoading={loading}
        labelKey={'business_name'}
        key={'id'}
        delay={400}
        className="typeahead"
        renderMenu={(results, menuProps, state) => {
          return (
            <Menu {...menuProps}>
              {results.map((result, index) => (
                <MenuItem key={index} option={result} position={index}>
                  {`${result.business_name} ( ${result.vat} )`}
                </MenuItem>
              ))}
              {results.length === 0 && (
                <div
                  style={{ marginLeft: '1em', cursor: 'pointer' }}
                  onClick={() => {
                    // const companyData = new CompanyClass();
                    // companyData.business_name = state.text;
                    setNewCompany(state.text);
                    setCompany({});
                  }}
                >
                  {t('ADD_COMPANY_CONTACT')}
                </div>
              )}
            </Menu>
          );
        }}
        renderMenuItemChildren={(option) =>
          `${option.business_name} ( ${option.vat} )`
        }
        onSearch={async (query) => {
          setLoading(true);
          const filter = JSON.stringify([
            { field: t('business_name'), type: 'like', value: query }
          ]);

          try {
            const result: AxiosResponse = await getCompanies(encodeURIComponent(filter));
            if (result.data.success) {
              setLoading(false);
              setCompanies(result.data.data);
            }
          } catch (error) {
            console.log(error);
          }
        }}
        onChange={async (selected) => {
          const selectedCompany = selected[0];
          if (selectedCompany) {
            setCompany(selectedCompany);
          }
        }}
        options={companies}
      />
      <hr />
      <>
        <div style={{ marginTop: '1em' }}>
          {company?.business_name && (
            <>
              <InputLabel>{t('COMPANY')}</InputLabel>
              <table id="contact-table">
                <tbody>
                  <tr>
                    <th>{t('BUSINESS_NAME')}</th>
                    <td>{company?.business_name}</td>
                  </tr>
                  <tr>
                    <th>{t('VAT')}</th>
                    <td>{company?.vat}</td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          {newCompany?.business_name && (
            <>
              {' '}
              <InputLabel>{t('COMPANY')}</InputLabel>
              <table id="contact-table">
                <tbody>
                  <tr>
                    <th>{t('BUSINESS_NAME')}</th>
                    <td>
                      <TextField
                        size="small"
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 }
                        }}
                        fullWidth
                        defaultValue={newCompany.business_name}
                        onChange={(e: any) => {
                          setBusinessName(e.target.value);
                        }}
                      ></TextField>
                    </td>
                  </tr>
                  <tr>
                    <th>{t('VAT')}</th>
                    <td>
                      <TextField
                        size="small"
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 }
                        }}
                        fullWidth
                        defaultValue={newCompany.vat}
                        onChange={(e: any) => {
                          setVat(e.target.value);
                        }}
                      ></TextField>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
        </div>
      </>
    </div>
  );
};

export default CompanyForm;
